export default __webpack_public_path__ + "static/steve-a9039e75391eb6537812321492d1296c.jpg";